import AnalyticsHelper from '../../../../../utils/analytics-helper';
export default class ChangePasswordSubview {
    constructor(parent) {
        this.parent = parent;
        this.router = parent.router;
        this.el = parent.el.querySelector('.change-password-view');
        this.button = this.el.querySelector('.change-password-button');
        this.bind();
    }

    bind() {
        this.button.addEventListener('click', (e) => {
            e.preventDefault();
            window.HONDA.MyAccount2.showModal({
                view: 'password-send-otp',
                close: true,
                password: true,
                callbacks: {
                    onLogout: () => {
                        this.router.update('dashboard');
                    }
                }
            });
            this.analyticsPush();
        });
    }

    analyticsPush() {
        AnalyticsHelper.push({
            event:'my_account',
            eventCategory:'my account',
            eventAction:'change password',
            eventLabel:`${dataLayer[0].productCategory}|My account|Change Password|internal|#`,
            actionType:'change password',
            businessUnit: dataLayer[0].productCategory,
            moduleName: 'My account',
            clickText: 'Change Password',
            clickType: 'internal',
            destinationURL: '',
        });
    }
}
